import * as Types from '../mutation-types'
import { set_one, remove, ADD_PENDING, ADD_REQUEST, REMOVE_PENDING, REMOVE_REQUEST } from '../mutation-mixins'

// noinspection JSUnusedGlobalSymbols
export default {

    ADD_PENDING, ADD_REQUEST, REMOVE_PENDING, REMOVE_REQUEST,

    [Types.SET_ONE]: set_one({ to: 'entities' }),
    [Types.REMOVE]: remove({ from: 'entities' }),

}
